import { render, staticRenderFns } from "./edit-task.vue?vue&type=template&id=73a1beec&scoped=true&"
import script from "./edit-task.vue?vue&type=script&lang=js&"
export * from "./edit-task.vue?vue&type=script&lang=js&"
import style0 from "./edit-task.vue?vue&type=style&index=0&id=73a1beec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a1beec",
  null
  
)

export default component.exports